import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MocksHandlerComponent } from './mocks-handler.component';
import { MockupsConfiguratorComponent } from './mockups-configurator/mockups-configurator.component';
import { MockupsProductsComponent } from './mockups-products/mockups-products.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MockupsProductsComponent,
        MockupsConfiguratorComponent,
        MocksHandlerComponent,
    ],
    exports: [MockupsProductsComponent, MockupsConfiguratorComponent, MocksHandlerComponent],
})
export class MocksHandlerModule {}
